import React, { memo, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { translateAdaptiveCardJson } from '../../translateAdaptiveCardJson';
import { createAdaptiveCard, removeCharacterCount, removeFirstChild } from '../util';
import hostConfigDark from '../util/microsoft-teams-dark.json';
import hostConfigLight from '../util/microsoft-teams-light.json';

const AdaptiveCardRenderer = ({
	adaptiveCardJson,
	disableEdit,
	setResponses,
	feedbackRequestStatus = null,
	theme = 'light',
	handleChange,
}) => {
	const cardContainerRef = useRef(null);
	const { t } = useTranslation(['biz-collab-form-builder-spa']);

	useEffect(() => {
		if (feedbackRequestStatus === 'CANCELLED') {
			return;
		}
		const translatedAdaptiveCardJson = translateAdaptiveCardJson(
			structuredClone(adaptiveCardJson),
			t,
		);
		if (disableEdit) {
			removeCharacterCount(translatedAdaptiveCardJson);
		}
		const hostConfig = theme === 'dark' ? hostConfigDark : hostConfigLight;
		const adaptiveCard = createAdaptiveCard(translatedAdaptiveCardJson, hostConfig);
		const renderedAdaptiveCard = adaptiveCard.render();
		cardContainerRef.current.innerHtml = '';
		removeFirstChild(cardContainerRef);
		cardContainerRef.current.appendChild(renderedAdaptiveCard);
		adaptiveCard.onInputValueChanged = () => {
			setResponses(
				adaptiveCard.getAllInputs().map(({ id, value }) => ({ id, value: value ?? '' })),
			);
			if (handleChange) {
				handleChange();
			}
		};
		document.querySelector('.ac-adaptiveCard').setAttribute('tabindex', '-1');
	}, [adaptiveCardJson, feedbackRequestStatus, setResponses, t, theme, handleChange, disableEdit]);

	return (
		<fieldset disabled={disableEdit} style={{ border: 'none' }}>
			<div id="adaptiveCardContainer" data-testid="adaptive-card-parent" ref={cardContainerRef} />
		</fieldset>
	);
};

export default memo(AdaptiveCardRenderer);
